// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-card-mask-IUWDHU{--template-card-mask-start:rgba(var(--coze-bg-3),0);--template-card-mask-end:rgba(var(--coze-bg-3),.96);background:linear-gradient(180deg,var(--template-card-mask-start)0%,var(--template-card-mask-end)100%)}.template-group-WwyVvR{grid-template-columns:repeat(3,1fr);gap:16px 1%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"template-card-mask": `template-card-mask-IUWDHU`,
	"templateCardMask": `template-card-mask-IUWDHU`,
	"template-group": `template-group-WwyVvR`,
	"templateGroup": `template-group-WwyVvR`
};
export default ___CSS_LOADER_EXPORT___;
